// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24Rui","icon":"styles_icon__dUv9V"};